export class DictionaryUtility {
  static convert<TKey extends string | number | symbol, TSource, TDestination>(source: { [key in TKey]: TSource }, convert: (key: TKey, source: TSource) => TDestination): { [key in TKey]: TDestination } {
    const results = {} as any;
    Object.keys(source).forEach(k => {
      const key = k as any as TKey;
      results[k] = convert(key, source[key]);
    });
    return results;
  }
}
